module.exports = __webpack_public_path__ + "vr-pat.png";